export default __webpack_public_path__ + "static/media/Greenhouse Outside.c1c98410.webp";